export default "__VITE_ASSET__CaeTen1m__"